import { useId } from 'react';

import { LockSimple } from '@phosphor-icons/react';
import classNames from 'classnames';

import type { TipJarCopy } from './TipJar.types';
import * as styles from './TipJarNote.css';
import { textButton } from './tipJarTheme.css';

type TipJarNoteProps = {
  value: string;
  maxLength: number;
  publicationName: string;
  copy: Pick<TipJarCopy, 'noteLabel' | 'notePlaceholder' | 'notePrivacy' | 'noteCharacterCount' | 'removeNote'>;
  onChange: (value: string) => void;
  onRemove?: () => void;
};

export const TipJarNote = ({ value, maxLength, publicationName, copy, onChange, onRemove }: TipJarNoteProps) => {
  const fieldId = useId();
  const privacyId = useId();
  const countId = useId();

  return (
    <div className={styles.note}>
      <div className={styles.header}>
        <label htmlFor={fieldId} className={styles.label}>
          {copy.noteLabel(publicationName)}
        </label>
        {onRemove && (
          <button type="button" className={classNames(textButton, styles.remove)} onClick={onRemove}>
            {copy.removeNote}
          </button>
        )}
      </div>
      <textarea
        id={fieldId}
        className={styles.field}
        rows={3}
        maxLength={maxLength}
        placeholder={copy.notePlaceholder}
        aria-describedby={`${privacyId} ${countId}`}
        value={value}
        onChange={(event) => onChange(event.target.value)}
      />
      <div className={styles.footer}>
        <p id={privacyId} className={styles.privacy}>
          <LockSimple className={styles.privacyIcon} size={12} weight="bold" aria-hidden />
          {copy.notePrivacy(publicationName)}
        </p>
        {/* Counts what maxLength counts, so the counter and the cap always agree. */}
        <span id={countId} className={styles.count} data-full={value.length >= maxLength}>
          {copy.noteCharacterCount(value.length, maxLength)}
        </span>
      </div>
    </div>
  );
};
